<template>
  <div class="fillcontain" >
    <head-top></head-top>
    <div class="select_container">
      <el-select v-model="value" placeholder="商品分类" style="width: 200px">
        <el-option
          v-for="item in categoryOptions"
          :key="item.typeId"
          :label="item.typeName"
          :value="item.typeId">
        </el-option>
      </el-select>
      <el-input v-model="input" placeholder="商品名称" style="width: 200px"></el-input>
      <el-button type="primary" @click="searchQuery">搜索</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          label="订单编号"
          property="orderNo">
        </el-table-column>
        <el-table-column
          label="姓名"
          property="name">
        </el-table-column>
        <el-table-column
          label="电话"
          property="phone">
        </el-table-column>
        <el-table-column
          label="商品名称"
          property="goodsName">
        </el-table-column>
        <el-table-column
          label="分类"
          property="typeName">
        </el-table-column>
        <el-table-column
          label="积分"
          property="integral">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          label="兑换时间"
          property="createTime">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.expressNo==null" @click="Editmaterial(scope.$index, scope.row)" type="text" size="small">填写快递</el-button>
            <el-button v-if="scope.row.expressNo!=null" @click="Editmaterial(scope.$index, scope.row)" type="text" size="small">修改快递</el-button>
            <el-button @click="Viewmaterial(scope.$index, scope.row)" type="text" size="small">查看</el-button>
            <!--<el-button @click="handleDelete(scope.$index, scope.row)" type="text" size="small">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

      <!--添加快递-->
      <el-dialog title="填写快递" :visible.sync="addFormVisible">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="快递公司" prop="name" >
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="快递单号" prop="id">
            <el-input v-model="addForm.id" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit()">提交</el-button>
        </div>
      </el-dialog>



      <!--查看快递-->
      <el-dialog title="查看快递" :visible.sync="addFormExpress" width="30%">
        <el-form label-position="left" inline class="demo-table-expand" >
          <el-form-item label="姓名">
            <span>{{ addForms.name }}</span>
          </el-form-item>
          <el-form-item label="电话">
            <span>{{ addForms.phone }}</span>
          </el-form-item>
          <el-form-item label="地址">
            <span>{{ addForms.adddress }}</span>
          </el-form-item>
          <el-form-item label="留言">
            <span>{{ addForms.message }}</span>
          </el-form-item>
          <el-form-item label="订单编号">
            <span>{{ addForms.orderNo }}</span>
          </el-form-item>
          <el-form-item label="快递">
            <span>{{ addForms.expressCompany }}</span>
          </el-form-item>
          <el-form-item label="单号">
            <span>{{ addForms.expressNo }}</span>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getOrderInfo,getComclassification,getExpress,getExpressDetail,getExpressDel } from "../api/api"
  export default {
    data(){
      return {
        tableData: [],
        categoryOptions: [],
        value:'',
        input:'',
        limit: 20,
        total: 0,
        currentPage: 1,
        addFormVisible: false,//新增界面是否显示
        addFormVisible2:false,
        addFormExpress: false,
        addLoading: false,
        //新增界面数据
        addForm: {
          name:'',
          id:''
        },
        addForms: [],
        Forms:[],
      }
    },
    components: {
      headTop,
    },
    created(){
      this.getOrderInfo();
      this.getComclassification()
    },
    mounted(){

    },
    methods: {
      //时间戳转换
      formatDate:function (value){
        let dateee = new Date(value.createTime).toJSON();
        return new Date(new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      //订单列表
      getOrderInfo(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
          typeId:this.value,
          goodsName:this.input
        };
        //获取排版管理列表
        getOrderInfo(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error=>{
          console.log(error);
        })
      },
      getComclassification(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        //获取商品分类列表
        getComclassification(params).then(res=>{
          this.categoryOptions= res.pageInfo
          let pageInfo = {
            typeName : '全部',
            typeId:''
          }
          this.categoryOptions.unshift(pageInfo)
        }).catch(error=>{
          console.log(error);
        })
      },
      searchQuery(){
        //  查询
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
          typeId:this.value,
          goodsName:this.input
        };
        getOrderInfo(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error=>{
          console.log(error);
        })
      },
      //填写快递
      Editmaterial(index,row){
        this.addFormVisible = true
        this.addForm.orderId = row.orderId
        if (row.expressCompany == null && row.expressNo == null) {
          this.addForm.name = ''
          this.addForm.id = ''
        }else {
          this.addForm.name = row.expressCompany
          this.addForm.id = row.expressNo
        }
      },
      addSubmit(){
        if (this.addForm.name == '' || this.addForm.id == ''){
          this.$message({
            type: 'error',
            message: '请填写完整信息'
          });
        }else {
          let params = {
            orderId : this.addForm.orderId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            expressCompany:this.addForm.name,
            expressNo:this.addForm.id
          }
          getExpress(params).then(res=>{
            this.addFormVisible = false
            this.getOrderInfo()
          }).catch(error=>{
            console.log(error);
          })
        }

      },
      //查看
      Viewmaterial(index,row){
        this.addFormExpress = true
        let params = {
          orderId : row.orderId,
        }
        getExpressDetail(params).then(res=>{
          this.addForms = res
          this.addFormVisible = false
        }).catch(error=>{
          console.log(error);
        })
      },
      handleDelete(index, row) {
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params = {
            orderId: row.orderId,
            operationId: JSON.parse(sessionStorage.getItem('user')).id,
          };
          getExpressDel(params).then(res => {
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: '删除订单成功'
              });
              this.tableData.splice(index, 1);
            } else {
              throw new Error(res.message)
            }
          }).catch(error => {
            this.$message({
              type: 'error',
              message: '删除订单失败'
            });
          })
        })
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getOrderInfo()
      },
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .el-dialog--small {
    width: 25%;
  }
</style>



// WEBPACK FOOTER //
// src/page/orderList.vue